import { gql } from '@apollo/client';

const GET_API_CREDENTIALS = gql`
    query GetApiCredentials($profileId: Int!, $environment: String!) {
        getApiCredentials(profileId: $profileId, environment: $environment) {
            clientId
            clientSecret
            error
        }
    }
`;

export default GET_API_CREDENTIALS;
